import { AxiosResponse, AxiosStatic } from "axios";
import { ICreationResponse } from "../../parsers/resolve";

export interface IFontsApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IFamily {
  family: string;
}

export enum SourceKind {
  Google = "google",
  Literal = "literal",
}

export enum FontStyle {
  FSNormal = "normal",
  FSItalic = "italic",
  FSOblique = "oblique",
}

export enum FontWeight {
  FW100 = "100",
  FW200 = "200",
  FW300 = "300",
  FW400 = "400",
  FW500 = "500",
  FW600 = "600",
  FW700 = "700",
  FW800 = "800",
  FW900 = "900",
}

export interface ISource {
  googleFont: IFamily;
  literalFont: IFamily;
  kind: SourceKind;
  fileFont: {
    name: string;
  };
}

export interface IFont {
  source: ISource;
  style: FontStyle;
  weight: FontWeight;
}

export interface IFullFontBody {
  displayName: string;
  deleted: boolean;
  italicFont: IFont;
  normalFont: IFont;
  boldFont: IFont;
  boldItalicFont: IFont;
  fallback: string[];
  owner: string;
}

export interface IFullFontResponse {
  displayName: string;
}

export interface IFontsApi {
  create: (font: IFullFontBody, accountId: string) => Promise<AxiosResponse<ICreationResponse<IFullFontResponse>>>;
  getEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse<string[]>>;
}
